(() => {
  const initialiseExpandableReviews = (section) => {
    section.querySelectorAll('[data-review-body]').forEach((body) => {
      const quote = body.querySelector('[data-review-quote]');
      const toggle = body.querySelector('[data-review-toggle]');
      if (!quote || !toggle || body.dataset.reviewToggleReady === 'true') return;

      body.dataset.reviewToggleReady = 'true';
      quote.classList.add('is-collapsed');
      toggle.hidden = true;
      toggle.setAttribute('aria-expanded', 'false');
      toggle.textContent = 'Read more';

      const updateToggleVisibility = () => {
        if (!quote.classList.contains('is-collapsed')) return;
        toggle.hidden = quote.scrollHeight <= quote.clientHeight + 2;
      };

      window.requestAnimationFrame(updateToggleVisibility);

      toggle.addEventListener('click', () => {
        const willExpand = quote.classList.contains('is-collapsed');
        quote.classList.toggle('is-collapsed', !willExpand);
        toggle.setAttribute('aria-expanded', String(willExpand));
        toggle.textContent = willExpand ? 'Read less' : 'Read more';
      });

      if ('ResizeObserver' in window) {
        const observer = new ResizeObserver(updateToggleVisibility);
        observer.observe(quote);
      } else {
        window.addEventListener('resize', updateToggleVisibility, { passive: true });
      }
    });
  };

  const initReviews = (scope = document) => {
    scope.querySelectorAll('[data-seq-reviews]').forEach((section) => {
      section.querySelectorAll('a[target="_blank"]').forEach((link) => {
        const relValues = (link.getAttribute('rel') || '')
          .split(/\s+/)
          .filter(Boolean);

        ['noopener', 'noreferrer'].forEach((value) => {
          if (!relValues.includes(value)) relValues.push(value);
        });

        link.setAttribute('rel', relValues.join(' '));
      });

      initialiseExpandableReviews(section);
      section.dataset.seqReviewsReady = 'true';
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initReviews());
  } else {
    initReviews();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initReviews(event.target);
  });
})();
